import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";

import {
  Unstable_Grid2 as Grid,
  Paper,
  Container,
  ImageListItem,
  Stack,
  Box,
  Typography,
} from "@mui/material";

import Logo from "../../assets/images/LOGO-FOOTER.png";

const PrivacyPolicyCard = ({ commercialFlagExtId }) => {
  const variant = "outlined";

  return (
    <Paper
      elevation={16}
      sx={{
        opacity: 0.9,
        position: "absolute",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)",
        // textAlign: "center",
        width: {
          xs: "90%",
          sm: "85%",
          md: "75%",
          lg: "60%",
          xl: "55%",
        },
        margin: "0 auto",
      }}
    >
      <Stack alignItems="center" justifyContent="flex-start">
        <ImageListItem>
          <Container>
            <img src={Logo} style={{ width: 200, marginBottom: 25 }}></img>
          </Container>
        </ImageListItem>
        <Container>
          <Box
            sx={{
              overflow: "scroll",
              wordWrap: "break-word",
              maxHeight: "80vh",
            }}
          >
            <Typography
              variant="body1"
              sx={{
                fontSize: ".9rem",
                fontWeight: 400,
                color: "#626262",
                textAlign: "center",
              }}
            >
              <strong>{`PRIVACY POLICY DEL SOFTWARE N.I.C. - NETWORK IMMOBILIARE CERCHIARA `}</strong>
            </Typography>
            <br />
            <Typography
              variant="body1"
              sx={{
                fontSize: "0.8rem",
                fontWeight: 400,
                color: "#626262",
              }}
            >
              {`Informazioni sul trattamento dei dati personali degli Utenti che utilizzano il software N.I.C. (Network Immobiliare Cerchiara), all’indirizzo https://nic-italia.com e la piattaforma https://app.nic-italia.com, domini di proprietà della società Cerchiara Immobil Group S.r.l.s. (C.F./P.Iva 11129070964), con sede legale in Monza (MB), via Pavoni n. 10, ai sensi dell’articolo 13 del Regolamento UE 2016/679 (cosiddetto G.D.P.R.) `}
            </Typography>
            <Typography
              variant="body1"
              sx={{
                fontSize: "0.8rem",
                fontWeight: 400,
                color: "#626262",
              }}
            >
              <strong>{`Perché queste informazioni `}</strong>
            </Typography>
            <Typography
              variant="body1"
              sx={{
                fontSize: "0.8rem",
                fontWeight: 400,
                color: "#626262",
              }}
            >
              {`Ai sensi del Regolamento UE 2016/679 (di seguito “GDPR”), questa pagina descrive le modalità di trattamento dei dati personali degli Utenti che utilizzano il presente software, dominio di proprietà della società Cerchiara Immobil Group S.r.l.s. (di seguito “la Proprietà”), accessibile per via telematica all’indirizzo IP: 38.242.158.204. `}
            </Typography>
            <Typography
              variant="body1"
              sx={{
                fontSize: "0.8rem",
                fontWeight: 400,
                color: "#626262",
              }}
            >
              <strong>{`Titolare del trattamento `}</strong>
            </Typography>
            <Typography
              variant="body1"
              sx={{
                fontSize: "0.8rem",
                fontWeight: 400,
                color: "#626262",
              }}
            >
              {`In conseguenza dell’utilizzo del presente software possono essere trattati dati relativi a persone fisiche e giuridiche identificate o identificabili.Titolare del trattamento di tali dati è la società Cerchiara Immobil Group S.r.l.s. (C.F./P.Iva 11129070964), con sede legale in Monza (MB), via Pavoni n. 10 (PEC: cerchiaraimmobilgroup@pec.it). 
Per ogni richiesta o informazione riguardante il trattamento dei dati personali è possibile contattare il Titolate del trattamento al seguente indirizzo e-mail: assistenza@nic-italia.com. `}
            </Typography>
            <Typography
              variant="body1"
              sx={{
                fontSize: "0.8rem",
                fontWeight: 400,
                color: "#626262",
              }}
            >
              <strong>{`Informativa privacy semplificata`}</strong>
            </Typography>
            <Typography
              variant="body1"
              sx={{
                fontSize: "0.8rem",
                fontWeight: 400,
                color: "#626262",
              }}
            >
              {`Lo scopo dell’informativa privacy è di fornire la massima trasparenza relativamente alle informazioni 
che il software e la piattaforma raccolgono e a come le usano.In ottemperanza degli obblighi derivanti dalla normativa nazionale (D. Lgs 30 giugno 2003 n. 196, Codice in materia di protezione dei dati personali, e successive modifiche) ed europea (Regolamento europeo per la protezione dei dati personali n. 679/2016, cosiddetto “GDPR”), il presente sito rispetta e tutela la riservatezza degli Utenti, ponendo in essere ogni sforzo possibile e proporzionato per non ledere i diritti degli stessi.Il presente software pone ad ogni modo in essere ogni sforzo possibile per tutelare la privacy degli Utenti e minimizzare la raccolta dei dati personali non essenziali.Per ulteriori informazioni si rinvia all’informativa completa qui di seguito riportata. `}
            </Typography>
            <Typography
              variant="body1"
              sx={{
                fontSize: "0.8rem",
                fontWeight: 400,
                color: "#626262",
              }}
            >
              <strong>{`Informativa privacy completa 
Base giuridica del trattamento `}</strong>
            </Typography>
            <Typography
              variant="body1"
              sx={{
                fontSize: "0.8rem",
                fontWeight: 400,
                color: "#626262",
              }}
            >
              {`Il presente software tratta i dati prevalentemente in base al consenso degli Utenti.Il conferimento del consenso avviene al momento dell’iscrizione al portale, tramite la compilazione di apposito form di registrazione. Con l’uso o la consultazione del software gli Utenti approvano la presente informativa privacy e acconsentono al trattamento dei loro dati personali in relazione alle modalità e alle finalità di seguito descritte, compresa l’eventuale diffusione a terzi se necessaria per l’erogazione di un servizio, ove richiesto tramite la compilazione dell’apposito modulo di comunicazione dei dati personali.Tipi di dati trattati e finalità del trattamentoDati di navigazioneI sistemi informatici e le procedure preposte al funzionamento di questo software acquisiscono, nel corso del loro normale esercizio, alcuni dati personali la cui trasmissione è implicita nell’uso dei protocolli di comunicazione di Internet.Tali dati, necessari per il corretto utilizzo del software, vengono anche trattati allo scopo di:• ottenere informazioni statistiche sull’uso del software (pagine più visitate, numero di Utenti per fascia oraria o giornaliera, aree geografiche di provenienza, ecc.);• controllare il corretto funzionamento dei servizi offerti.I dati di navigazione non persistono per più di un anno e vengono cancellati immediatamente dopo la loro aggregazione (salve eventuali necessità di accertamento di reati da parte dell’Autorità giudiziaria).Dati comunicati dall’UtenteLa registrazione sul software e l’accesso alla propria area personale del software comportano l’acquisizione da parte della società Titolare del trattamento di tutti i dati personali anche sensibili dell’Utente, in quanto necessari all’espletamento dell’attività del network; tali dati verranno utilizzati in conformità alla legislazione vigente in materia.L’invio esplicito e volontario da parte dell’Utente di dati relativi a terzi all’interno del software, nonché la compilazione e l’inoltro dei moduli presenti sul software al fine di inviare le segnalazioni di potenziali clienti del network, comportano l’acquisizione dei dati di contatto dei terzi, nonché di tutti i dati personali inclusi nelle comunicazioni, necessari ad espletare l’attività di mediazione immobiliare.Destinatari dei datiSono destinatari dei dati raccolti a seguito dell’utilizzo del presente software il Titolare del trattamento e la proprietà. I dati personali raccolti sono altresì trattati dal personale e da eventuali 
￼ ￼ 
collaboratori del Titolare del trattamento, che agiscono sulla base di specifiche istruzioni fornite in ordine a finalità e modalità del trattamento medesimo.Luogo del trattamentoI dati raccolti dal software sono trattati presso la sede legale del Titolare del Trattamento, Cerchiara Immobil Group S.r.l.s. (C.F./P.Iva 11129070964), con sede legale in Monza (MB), via Pavoni n. 10, nonché presso il datacenter del web Hosting “Contabo” (ed in particolare presso la sede in Germania), che si trova nello Spazio Economico Europeo ed agisce in conformità delle norme europee. 
Periodo di conservazione dei dati 
I dati raccolti dal software durante il suo funzionamento sono conservati per il tempo strettamente necessario a svolgere le attività precisate. Alla scadenza i dati saranno cancellati o anonimizzati, a meno che non sussistano ulteriori finalità per la conservazione degli stessi.I dati (indirizzo IP) utilizzati a fini di sicurezza del software (blocco tentativi di danneggiare il sito) sono conservati per un anno. 
Trasferimento dei dati raccolti a terze parti 
I dati rilevati dal software generalmente non vengono forniti a terzi, tranne che in casi specifici: legittima richiesta da parte dell’Autorità Giudiziaria e nei soli casi previsti dalla legge; qualora sia necessario per la fornitura di uno specifico servizio richiesto dell’Utente; per l’esecuzione di controlli di sicurezza o di ottimizzazione del sito. 
Trasferimento dei dati in Paesi extra UE 
Il presente software non opera trasferimento dei dati presso Paesi extra UE, non potendosi in tal caso garantire un adeguato rispetto degli standards di trattamento dei dati personali imposti dalla vigente normativa europea, così come ribadito dalla Corte di Giustizia dell’Unione Europea all’interno della Sentenza “Schrems II” del 16 luglio 2020 (per maggiori informazioni è possibile accedere ai seguenti link - ENG: The Court of Justice invalidates Decision 2016/1250 on the adequacy of the protection provided by the EU-US Data Protection Shield (europa.eu); ITA: La Corte dichiara invalida la decisione 2016/1250 della Commissione sull'adeguatezza della protezione offerta dal regime dello scudo UE-USA per la privacy (europa.eu). 
Cookie 
Questo software fa uso di cookie, files di testo che vengono registrati sul terminale dell’Utente oppure che consentono l’accesso ad informazioni sul terminale dell’Utente. I cookie permettono di conservare informazioni sulle preferenze degli Utenti, sono utilizzati al fine di verificare il corretto funzionamento del software e di migliorarne le funzionalità, personalizzando il contenuto delle pagine in base al tipo del browser utilizzato, oppure per semplificarne la navigazione automatizzando le procedure (es. login, lingua sito), ed infine per l’analisi dell’uso del software da parte degli Utenti. 
￼ ￼ ￼ ￼ ￼ 
Misure di sicurezza 
Il Titolare del trattamento dei dati personali gestisce i dati degli Utenti in maniera lecita e corretta, adottando le opportune misure di sicurezza volte ad impedire accessi non autorizzati, divulgazione, modifica o distruzione non autorizzata dei dati.Si impegna inoltre a tutelare la sicurezza dei dati personali durante il loro invio attraverso l’utilizzo di crittografia asimmetrica a livello di trasporto (TLS e HTTPS) e crittografia simmetrica con algoritmo AES256c-b-c (standard di sicurezza ap). 
Il trattamento dei dati viene effettuato mediante strumenti informatici e/o telematici, con modalità organizzative e con logiche strettamente correlate alle finalità indicate.Oltre al Titolare del trattamento, in alcuni casi potrebbero avere accesso ai dati categorie di incaricati coinvolti nell’organizzazione del software e del network, ovvero soggetti esterni (come fornitori di servizi tecnici terzi, hosting provider e simili), i quali dovranno garantire di attenersi rigorosamente alle procedure e limitazioni previste con la presente privacy policy. 
Diritti dell’Utente 
Ai sensi del Regolamento UE 679/2016 (GDPR) e dell’art. 7 del D. Lgs. 30 giugno 2003, n. 196, l’Utente può, secondo le modalità e nei limiti previsti dalla vigente normativa, esercitare i seguenti diritti: non prestare il consenso al trattamento dei dati personali che lo riguardano ai fini di invio di materiale pubblicitario o di vendita diretta o per il compimento di ricerche di mercato o di comunicazione commerciale; 
		  richiedere la conferma dell’esistenza di dati personali che lo riguardano (diritto di accesso); 
		  conoscernel’origine; 
		  ricevernecomunicazioneintelligibile; 
		  avere informazioni circa la logica, le modalità e le finalità del trattamento; 
		  richiederne l’aggiornamento, la rettifica, l’integrazione, la cancellazione, la trasformazione in forma anonima, il blocco dei dati trattati in violazione di legge, ivi compresi quelli non più necessari al perseguimento degli scopi per i quali sono stati raccolti; nei casi di trattamento basato su consenso, ricevere al solo costo dell’eventuale supporto, i suoi dati forniti al titolare, in forma strutturata e leggibile da un elaboratore di dati e in un formato comunemente usato da un dispositivo elettronico;  il diritto di presentare un reclamo all’Autorità di Controllo (Garante per la Protezione dei Dati Personali “GPDP”), al seguente link Reclami - Garante Privacy; nonché, più in generale, esercitare tutti i diritti che gli sono riconosciuti dalle vigenti disposizioni di legge. 
￼ ￼ 
Le richieste vanno rivolte con apposita istanza al Titolare del trattamento, via e-mail all’indirizzo assitenza@nic-italia.com, che provvederà a evadere la richiesta non appena possibile e comunque entro un termine congruo non superiore a 30 giorni, ovvero a motivare per iscritto entro 30 giorni le ragioni che richiedano un tempo di risposta superiore. 
Aggiornamenti 
La presente privacy policy è aggiornata alla data del 29 maggio 2023. 
`}
            </Typography>
          </Box>
        </Container>
      </Stack>
    </Paper>
  );
};

export default PrivacyPolicyCard;
